import React, {Component} from 'react';
import iconsSvg from '../../assets/img/svgLib/iconsSvg';
import PropTypes from 'prop-types';
import './SupplyFullInfo.scss';
import classNames from 'classnames';

class SupplyFullInfo extends Component{
  static propTypes = {
    supply: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      activeMenuItem: 'reviewInfo',
      progressMin: this.props.supply.supplyMore.supplyInformation.supplyPriceClose,
      progressMax: this.props.supply.amount,
    }
  }

  handlerMenu = activeMenuItem => {
    this.setState({
      activeMenuItem
    })
  }

  get reviewInfo() {
    const {supply} = this.props;
    const {supplyMore} = supply;
    const {supplyInformation} = supplyMore;
    return (
      <div>
        <div className={'block'} style={{height: '16px'}}>
          <div className={'title'}>
            {`Договор поставки №${supply.supplyAgreementNumber}`}
          </div>
          <div className={'status'}>
            {`Статус: ${supplyMore.supplyInformation.supplyStatus}`}
          </div>
        </div>
        <div className={'block'}>
          <div className={'titleBig'}>
            Стоимость поставки
          </div>
          <div className={'informBlock'}>
            <div className={'oneItem'}>
              <div className={'text'}>Дата поставки по договору</div>
              <div className={'digit'}>{supply.supplyAgreementDate}</div>
            </div>
            <div className={'oneItem'}>
              <div className={'text'}>Сумма фиксируемой поставки (закрытый объем)</div>
              <div className={'digit'}>{`${supplyInformation.supplyPrice} руб.`}</div>
            </div>
            <div className={'oneItem'}>
              <div className={'text'}>Отсрочка по договору</div>
              <div className={'digit'}>{`${supply.delay} дней`}</div>
            </div>
          </div>
        </div>
        <div className={'block'}>
          <div className={'titleBig'}>
            Стоимость поставок по договору
          </div>
          <div className={classNames('flexBoxBetween', 'informBlock')}>
            <div className={'text'}>Общая сумма договоров</div>
            <div className={'amount'}>{`${this.state.progressMax} руб.`}</div>
          </div>
          {this.progressBar}
          <div className={classNames('flexBoxBetween', 'informBlock')}>
            <div className={'text'}>Выполненный объем поставок</div>
            <div className={'amount'}>{`${this.state.progressMin} руб.`}</div>
          </div>
        </div>
        <div className={'block'}>
          <div className={'titleBig'}>
            Взаимные расчеты сторон
          </div>
            <div className={'left'}>
              <div className={'digit'} style={{marginBottom: '10px'}}>{`${supplyInformation.supplyPriceReceivables} руб.`}</div>
              <div className={'digit'}>{`${supplyInformation.supplyPriceNetting} руб`}</div>
            </div>
            <div className={'right'}>
              <div className={'text'} style={{marginBottom: '10px'}}>Наличие дебиторской задолженности Поставщика перед Дебитором</div>
              <div className={'text'}>Сумма открытых договоров взаимозачета</div>
            </div>

        </div>

      </div>
    )
  }

  get documents() {
    const {supply} = this.props;
    const {supplyMore} = supply;
    const {supplyDocuments} = supplyMore;
    return (
      <div className={'documents'}>
        <div className={'titleBlock'}>
          Договор поставки
        </div>
        {supplyDocuments[0].supplyAgreement.map((item, i) => {
          return (<div key={`doc_${i}`} className={'blockDoc'}>
            <div className={'icon'}>
              {iconsSvg.document}
            </div>
            <div className={'text'}>
              {`${item.supplyAgreementNumber} от ${item.supplyAgreementDate}`}
            </div>
            <div className={'text'}>
              Подтверждене Дебитора (Покупателя)
            </div>
              <div className={'check'}>{item.debtorCheck ? iconsSvg.done : `X`}</div>
            <div className={'text'}>
              Подтверждене Кредитора (Поставщика)
            </div>
            <div className={'check'}>{item.vendorCheck ? iconsSvg.done : `X`}</div>
          </div>)
        })}
        <div className={'titleBlock'}>
          Взаимные расчеты сторон
        </div>
        {supplyDocuments[1].supplyConfirm.map((item, i) => {
          return (
            <div key={`doc2_${i}`} className={'blockDoc'}>
              <div className={'icon'}>
                {iconsSvg.document}
              </div>
              <div className={'text'}>
                {`${item.supplyAgreementNumber} от ${item.supplyAgreementDate}`}
              </div>
              <div className={'text'}>
                Подтверждене Дебитора (Покупателя)
              </div>
              <div className={'check'}>{item.debtorCheck ? iconsSvg.done : `X`}</div>
              <div className={'text'}>
                Подтверждене Кредитора (Поставщика)
              </div>
              <div className={'check'}>{item.vendorCheck ? iconsSvg.done : `X`}</div>
            </div>
          )
        })}
        <div className={'titleBlock'}>
          Взаимные расчеты сторон
        </div>
        {supplyDocuments[2].supplyNetting.map((item, i) => {
          return (
            <div key={`doc3_${i}`} className={'blockDoc'}>
              <div className={'icon'}>
                {iconsSvg.document}
              </div>
              <div className={'text'}>
                {`${item.supplyAgreementNumber} от ${item.supplyAgreementDate}`}
              </div>
              <div className={'text'}>
                Подтверждене Дебитора (Покупателя)
              </div>
              <div className={'check'}>{item.debtorCheck ? iconsSvg.done : `X`}</div>
              <div className={'text'}>
                Подтверждене Кредитора (Поставщика)
              </div>
              <div className={'check'}>{item.vendorCheck ? iconsSvg.done : `X`}</div>
            </div>
          )
        })}
      </div>
    )
  }

  get progressBar() {
    const {progressMax, progressMin} = this.state;
    const present = Math.trunc(progressMin / progressMax * 100);
    return (
      <div className={'progressBar'}>
        <div className={'done'} style={{width: `${present}%`}}/>
      </div>
    )
  }

  render() {
    const {reviewInfo, documents} = this;
    const {activeMenuItem} = this.state;
    return (
      <div className={'fullinfo'}>
        <div className={'menu'}>
          <div className={classNames('menuItem', {'active': activeMenuItem === 'reviewInfo'})}
               onClick={() => this.handlerMenu('reviewInfo')}>
            Описание
          </div>
          <div className={classNames('menuItem', {'active': activeMenuItem === 'documents'})}
               onClick={() => this.handlerMenu('documents')}>
            Документы
          </div>
        </div>
        <div className={'content'}>
          {activeMenuItem === 'reviewInfo' ?
            reviewInfo : documents}
        </div>
      </div>
    )
  }
}

export default SupplyFullInfo



// WEBPACK FOOTER //
// ./src/shared/SupplyFullInfo/SupplyFullInfo.js